import Vue from "vue";
import { ToastPlugin, ModalPlugin, BootstrapVueIcons } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import i18n from "@/libs/i18n/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import lodash from "lodash";
import toPersianNum from "./mixins/toPersianNum";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Vuelidate from "vuelidate";
import VueCookies from "vue-cookies";
import breadcrumb from "@/mixins/breadcrumb";
// import VueSocketIOExt from "vue-socket.io-extended";
// import { io } from "socket.io-client";
import "@/libs/acl";
import imageViewer from "vue-image-viewer";
import parsetoken from "@/plugins/parsetoken";
import VueUploadComponent from "vue-upload-component";
import VueHtmlToPaper from "vue-html-to-paper";
import vuetify from "@/plugins/vuetify";
import "vue-good-table/dist/vue-good-table.css";
import "vue-select/dist/vue-select.css";
import "filepond/dist/filepond.min.css";
import vClickOutside from "v-click-outside";
// import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
// Vue.use(VueGoodTablePlugin);

Vue.component("date-picker", VuePersianDatetimePicker);
// Vue.component('handyUploader', handyUploader);

import "./global-components";
import "@/libs/portal-vue";
import "@/libs/toastification";
//import draggable from "vuedraggable";
import { Integrations } from "@sentry/tracing";
import VueDraggable from 'vuedraggable'

import * as Sentry from "@sentry/vue";

Vue.use(ToastPlugin);
Vue.use(BootstrapVueIcons);
Vue.use(ModalPlugin);
Vue.use(lodash);
Vue.use(VueCompositionAPI);
Vue.mixin(toPersianNum);
Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.use(imageViewer);
Vue.use(parsetoken);
Vue.use(vClickOutside);
Vue.use(VueDraggable)

Vue.use(VueHtmlToPaper, {
  // name: '_blank',
  specs: [
    "fullscreen=yes",
    // 'titlebar=yes',
    "scrollbars=yes",
  ],
  styles: [
    "https://unpkg.com/bootstrap-vue@latest/dist/bootstrap-vue.css",
    "https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css",
    "/print.css",
  ],
  autoClose: false,
});

/**+
 * socket.io
 */
// Vue.use(new VueSocketIO({
//   debug: true,
//   // connection: SocketIO("http://localhost:3000")
//   connection:"http://localhost:3000"
// }))
// var allowedOrigins = "http://localhost:8081";
// var allowedOrigins = "http://localhost:* http://127.0.0.1:*";
// const socket = io('http://localhost:3000',{origins: allowedOrigins});

// const socket = io('http://localhost:3000');

// var socket = io('http://yourDomain:port', { transports: ['websocket', 'polling', 'flashsocket'] });

// var connectionOptions =  {
//   "force new connection" : true,
//   "reconnectionAttempts": "Infinity",
//   "timeout" : 10000,
//   "transports" : ["websocket"]
// };
// this.socket = io.connect('http://localhost:5000',connectionOptions);

// const socket = io('http://localhost:3000', { transports : ['websocket'] });
// const socket = io(process.env.VUE_APP_BASE_URL_WS, {
//   transports: ["websocket"],
// });
// const socket = io('http://localhost:3000', { transports : ['websocket','polling'] });
//Vue.use(VueSocketIOExt, socket);

// Vue.use(draggable);
//Vue.component("draggable", draggable);
Vue.component("VueUploadComponent", VueUploadComponent);

// import core styles
require("@core/scss/core.scss");
require("../public/print.css");

// import assets styles
require("@/assets/scss/style.scss");
// import assets styles
require("@/assets/css/custom.css");
require("@/assets/scss/print.scss");
require("@/assets/scss/custom-rtl.scss");

Vue.config.productionTip = false;
Vue.mixin({
  mixins: [breadcrumb],
  mounted: function () {
    let tagArr = document.getElementsByTagName("input");
    for (let i = 0; i < tagArr.length; i++) {
      tagArr[i].autocomplete = "off";
    }
  },
});

// Sentry.init({
//   Vue,
//   dsn: "https://e2ef7ea6c83a44259532b20d5003971e@sentry.mirorix.io/10",
//   integrations: [
//   new Integrations.BrowserTracing({
//     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//     tracingOrigins: ["localhost", "my-site-url.com", /^\//],
//   }),
// ],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
// });

const app = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");

store.$app = app;
